// extracted by mini-css-extract-plugin
export default {"eventcontainer":"Event_eventcontainer__iqpXE","gridrow":"Event_gridrow__4aizO","eventtitle":"Event_eventtitle__UdoZK"};